<template>
  <printable>
    <div
      style="
        border: solid;
        border-width: 2px;
        padding: 0px;
        width: 100%;
        font-size: 16px;
      "
    >
      <table style="width: 100%" class="header" cellpadding="0" cellspacing="0">
        <tr>
          <td
            style="
              width: 50%;
              text-align: center;
              font-weight: bold;
              text-transform: uppercase;
            "
          >
            <div></div>
            {{ data.title }} {{ data.team }}
            <div>
              {{ data.perusahaan }}
            </div>
            <div>
              {{ dFormat(data.start_date, "d_M_Y") }}
              {{ " - " + dFormat(data.end_date, "d_M_Y") }}
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div
      style="
        margin-top: 10px;
        border: solid;
        border-width: 1px;
        padding: 0px;
        width: 100%;
        font-size: 14px;
      "
    >
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tr class="text-center" style="text-width: 20px">
          <td style="width: 20%">Cust.No</td>
          <!-- <td style="width: 15%">Toko</td> -->
          <td style="width: auto">Description</td>
          <td style="width: 10%">Debet</td>
          <td style="width: 10%">Credit</td>
        </tr>
        <template v-for="(pelunasan, i) in data.data">
          <tr :key="i">
            <td>
              {{ pelunasan.no_acc }}
              {{ pelunasan.cust_no ? " [" + pelunasan.cust_no + "]" : "" }}
            </td>
            <!-- <td v-html="pelunasan.nama_toko" /> -->
            <td style="width: auto; text-transform: uppercase">
              {{ _fetch(pelunasan.bank) }}
              {{ _fetch(pelunasan.no_rekening) }}
              {{ _fetch(pelunasan.no_bg) }}
              {{ _fetch(pelunasan.status) }}
              {{ "[" + clearCase(pelunasan.tipe) + "]" }}
            </td>
            <td class="currency">
              {{ pelunasan.sum_nominal | currency }}
            </td>
            <td class="currency">0</td>
          </tr>
          <tr
            v-for="(penjualan, j) in pelunasan.penjualan"
            :key="i + j"
            class="detail"
          >
            <td></td>
            <td class="desc">
              {{
                penjualan.po_manual == ""
                  ? penjualan.id_penjualan
                  : penjualan.po_manual
              }}
              -
              {{ penjualan.nama_toko }}
              /
              {{ penjualan.no_invoice }}
              /
              {{ dFormat(penjualan.delivered_at, "d.m.Y") }}
              /
              {{ penjualan.nama_tim }}
              /
              {{ penjualan.keterangan }}
            </td>
            <td class="currency">0</td>
            <td class="currency">{{ penjualan.nominal | currency }}</td>
          </tr>
        </template>
        <tr style="font-weight: bold">
          <td colspan="1">TOTAL</td>
          <td style="text-transform: uppercase" v-html="data.terbilang"></td>
          <td class="currency">{{ data.total | currency }}</td>
          <td class="currency">{{ data.total | currency }}</td>
        </tr>
      </table>
      <div class="row" style="margin-top: 10px">
        <div class="col-12">
          <table style="width: 100%; font-size: 14px" class="table-border">
            <tr>
              <td style="width: 15%; text-align: center">Input Data</td>
              <td style="width: 25%; text-align: center">Disetujui</td>
              <td style="width: 35%; text-align: center" colspan="2">
                Diperiksa
              </td>
              <td style="width: 25%; text-align: center">Dibuat</td>
            </tr>
            <tr>
              <td style="width: 15%; text-align: center; height: 70px"></td>
              <td style="width: 15%; text-align: center"></td>
              <td style="width: 15%; text-align: center"></td>
              <td style="width: 15%; text-align: center"></td>
              <td style="width: 15%; text-align: center"></td>
            </tr>
            <tr>
              <td style="width: 15%; text-align: center; height: 30px"></td>
              <td style="width: 15%; text-align: center"></td>
              <td style="width: 15%; text-align: center"></td>
              <td style="width: 15%; text-align: center"></td>
              <td style="width: 15%; text-align: center"></td>
            </tr>
            <tr>
              <td style="width: 15%; text-align: center">Operator</td>
              <td style="width: 15%; text-align: center">Pemimpin</td>
              <td style="width: 15%; text-align: center">Acct. Manager</td>
              <td style="width: 15%; text-align: center">Spv. Acct</td>
              <td style="width: 15%; text-align: center">Staff Admin</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </printable>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "printSemuaInvoice",
  mixins: [helper],

  data() {
    return {
      data: {},
    };
  },

  methods: {
    getData() {
      this.data = JSON.parse(localStorage.semuaInvoice);
    },
    _fetch(payload) {
      return payload ? payload + " / " : "";
    },
  },

  mounted() {
    // window.close()
    this.getData();
  },
};
</script>
<style scoped>
th,
tr,
td {
  padding: 10px;
}
.currency {
  text-align: right;
  width: 10%;
}
.detail .desc {
  padding-left: 50px;
  text-transform: uppercase;
}
</style>
